import { Global, css } from '@emotion/react'

export function GlobalStyles() {
  return (
    <Global
      styles={css`
        /* * {
          font-family: 'Maledpan', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
          font-weight: 'bold';
        } */

        body {
          font-family: 'Bai Jamjuree', -apple-system, BlinkMacSystemFont,
            'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
            'Helvetica Neue', sans-serif;
          font-weight: 500;
          background: #000102;
        }

        .ant-calendar-picker-input,
        .ant-calendar-picker {
          width: 100%;
        }
        h4.ant-typography {
          /* font-family: 'Sarabun'; */
          line-height: 1.9;
        }

        .ant-form-item {
          margin-bottom: 32px;
        }

        .ant-form-item-label {
          font-size: 20px;
          /* font-family: 'Sarabun'; */
        }

        .ant-form-item-children > textarea {
          /* font-family: 'Sarabun'; */
          line-height: 1.8;
          font-size: 16px;
        }

        .ant-form-item-control {
          /* font-family: 'Sarabun'; */
        }
      `}
    />
  )
}
